import { useForm, validators } from "@hooks";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { helpers, Constants } from "@shared";
import { Button, TextField, ShowPassword } from "@common";

interface LoginProps {
    submit: (values: { email: string; password: string }) => void | Promise<void>;
    initial?: { email?: string; password?: string };
    children?: React.ReactNode;
}

const Login = ({ submit, initial = {}, children }: LoginProps) => {

    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const initialState = { email: ``, password: ``, ...initial };

    const validations = {
        email: (val: string) => validators.isValidEmail(val) || { email: `Please use a valid email address.` },
        password: (val: string) => validators.hasValue(val) || { password: `Password is required` }
    };

    const { values, errors, changeHandler, submitHandler } = useForm(initialState, {}, validations, submit);

    const reset = () => {
        helpers.navigateStart(location, navigate, Constants.Flows.sendPasswordReset.id, undefined, { email: values.email }, params);
    };

    const isFormSubmittable = values.email && values.email.trim().length > 0 && values.password && values.password.trim().length > 0;

    return (
        <>
            {children}
            <form method="POST" className="w-full flex flex-col gap-8" onSubmit={submitHandler} >
                <div className="flex flex-col gap-4">
                    <TextField
                        type="email"
                        name="email"
                        placeholder="Email*"
                        value={values.email}
                        onChange={changeHandler}
                        error={errors.email}
                    />
                    <ShowPassword
                        name="password"
                        placeholder="Password*"
                        value={values.password}
                        onChange={changeHandler}
                        error={errors.password}
                    />
                    <div>
                        <Button
                            variant="link"
                            size="sm"
                            onClick={reset}
                        >
                            Forgot your password?
                        </Button>
                    </div>
                </div>
                <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    className="w-full"
                    disabled={!isFormSubmittable}
                >
                    Login
                </Button>
            </form>
        </>
    );
};

export default Login;
